module.exports = __webpack_public_path__ + "static/media/rooms-ch2.88cc4cde.png";